(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('home-project-service-details', {
            parent: 'entity',
            url: '/home-project-service-details',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.homeProjectServiceDetails.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/home-project-service-details/home-project-service-details.html',
                    controller: 'HomeProjectServiceDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('homeProjectServiceDetails');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('home-project-service-details-detail', {
            parent: 'home-project-service-details',
            url: '/home-project-service-details/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.homeProjectServiceDetails.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/home-project-service-details/home-project-service-details-detail.html',
                    controller: 'HomeProjectServiceDetailsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('homeProjectServiceDetails');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HomeProjectServiceDetails', function($stateParams, HomeProjectServiceDetails) {
                    return HomeProjectServiceDetails.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'home-project-service-details',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('home-project-service-details-detail.edit', {
            parent: 'home-project-service-details-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-project-service-details/home-project-service-details-dialog.html',
                    controller: 'HomeProjectServiceDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HomeProjectServiceDetails', function(HomeProjectServiceDetails) {
                            return HomeProjectServiceDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('home-project-service-details.new', {
            parent: 'home-project-service-details',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-project-service-details/home-project-service-details-dialog.html',
                    controller: 'HomeProjectServiceDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectId: null,
                                serviceId: null,
                                cafPin: null,
                                district: null,
                                status: null,
                                serviceName: null,
                                businessEntity: null,
                                departmentName: null,
                                ageing: null,
                                lastComments: null,
                                lastActionDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('home-project-service-details', null, { reload: 'home-project-service-details' });
                }, function() {
                    $state.go('home-project-service-details');
                });
            }]
        })
        .state('home-project-service-details.edit', {
            parent: 'home-project-service-details',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-project-service-details/home-project-service-details-dialog.html',
                    controller: 'HomeProjectServiceDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HomeProjectServiceDetails', function(HomeProjectServiceDetails) {
                            return HomeProjectServiceDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('home-project-service-details', null, { reload: 'home-project-service-details' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('home-project-service-details.delete', {
            parent: 'home-project-service-details',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-project-service-details/home-project-service-details-delete-dialog.html',
                    controller: 'HomeProjectServiceDetailsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HomeProjectServiceDetails', function(HomeProjectServiceDetails) {
                            return HomeProjectServiceDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('home-project-service-details', null, { reload: 'home-project-service-details' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
